import React from 'react';

import styles from './styles/type-box.module.css';

import {ReactComponent as RadioActive} from '../../../assets/radio/radio-active.svg';
import {ReactComponent as Radio} from '../../../assets/radio/radio.svg';

export default function TypeBox({ fileType, changeFileType }) {
    const typeMap = [
        { id: 1, name: '일반 학습 용', value: 'ORIGINAL' },
        { id: 2, name: 'FAQ 문서', value: 'TEMPLATE' }
    ];

    return (
        <div className={styles.wrapper}>
            {typeMap.map((type) => {
                const { id, name, value } = type;
                return (
                    <div key={id} onClick={() => changeFileType(value)}>
                        {fileType === value ? <RadioActive /> : <Radio />}
                        <p>{name}</p>
                    </div>
                );
            })}
        </div>
    );
}
